// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3uyCw","text":"styles_text__1Pwo6","textPhone":"styles_textPhone__1givw","confirmButton":"styles_confirmButton__1lohL"};